module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Darktide","short_name":"Darktide","description":"Warhammer 40,000: Darktide is the new co-op focused experience from the award-winning team behind the Vermintide series.","start_url":"/","background_color":"#fff","theme_color":"#ffcc00","display":"standalone","icon":"src/images/DT-favicon-grad.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"4a219bedf6da98969265fb70007474cf"},
    },{
      plugin: require('../node_modules/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[],"offset":-75},
    },{
      plugin: require('../node_modules/gatsby-plugin-facebook-multi-pixels/gatsby-browser.js'),
      options: {"0":{"dev":false,"alias":"Fatshark","pixelId":"944017466309004","viewContent":true,"pageView":true},"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-twitter-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"o8hem"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
